import Cookies from 'js-cookie';
import {createTrapFun} from "../../front/helpers/helpers";

window.MOMENTUM = window.MOMENTUM || {};

export function initLogin() {
    const root         = document.querySelector('[data-block="Login"]'),
          // form = document.getElementById('momentumLogin'),
          bodyCover    = document.querySelector('.body-cover'),
          logoutButton = root.querySelector('.is--for--logout'),
          closeBtn     = root.querySelector('.-closeBtn');

    if (!root) {
        return;
    }

    let form = document.getElementById('momentumLogin');
    const summaryWrapper = root.querySelector('.summary-wrapper');

    root.querySelector('.summary-toggle')?.addEventListener('click', () => {
        summaryWrapper.classList.toggle('is-visible');
    });

    root.querySelector('.summary-close')?.addEventListener('click', () => {
        summaryWrapper.classList.remove('is-visible');
    });


    closeBtn.addEventListener('click', () => {
        document.dispatchEvent(new Event('rb.login.hide'));
    });

    if (logoutButton) {
        logoutButton.addEventListener('click', () => {
            requestLogout();
        });
    }


    let isShown        = false,
        lastShown      = null,
        isFormRendered = false;

    document.addEventListener('rb.login.show', show);
    document.addEventListener('rb.login.hide', hide);
    document.addEventListener('rb.login.toggle', toggle);

    document.addEventListener('click', event => {
        if (!root.contains(event.target) && event.target !== root && new Date() - lastShown > 10) {
            hide();
        }
    });

    function show() {
        let lastFocusedElement = document.getElementById('toggle-login');
        let focusableElements = [].slice.call(root.querySelectorAll('a, button'));
        let firstTabStop = focusableElements[0];
        let lastTabStop = focusableElements[focusableElements.length - 1];

        console.log(firstTabStop);
        console.log(lastTabStop);

        if (!isFormRendered) {
            const loginTemplate = document.getElementById('loginTemplate');
            const loginWrapper = root.querySelector('#momentumLoginWrapper');

            if (loginWrapper) {
                loginWrapper.insertAdjacentHTML('afterbegin', loginTemplate.innerHTML);
            }

            form = document.getElementById('momentumLogin');
            form && initForm();

            isFormRendered = true;
        }

        isShown = true;
        root.classList.add('is--active');
        document.dispatchEvent(new Event('rb.login.shown'));
        lastShown = new Date();
        bodyCover.classList.add('visible');

        root.inert = false;

        setTimeout(() => {
            root.querySelector('a').focus()
        }, 0)

        let trapFun = createTrapFun(lastFocusedElement, firstTabStop, lastTabStop, hide)

        root.addEventListener('keydown', trapFun);
    }

    function hide() {
        isShown = false;
        root.classList.remove('is--active');
        root.inert = true;
        document.dispatchEvent(new Event('rb.login.hidden'));
        bodyCover.classList.remove('visible');

    }

    function toggle() {
        document.dispatchEvent(new Event(root.classList.contains('is--active') ? 'rb.login.hide' : 'rb.login.show'));
    }

    function requestLogout() {
        MomAPI.logout(function() {
            Cookies.remove('full_name');
            Cookies.remove('intern_client');
            Cookies.remove('momentum_login');
            window.location.href = '/';
        });
    }

    function initForm() {
        const fields          = [].slice.apply(root.querySelectorAll('.-field')),
              emailInput      = root.querySelector('.is--email .-input'),
              passwordInput   = root.querySelector('.is--password .-input'),
              passwordToggler = root.querySelector('.-password-toggler');

        passwordToggler.addEventListener('click', togglePassword);
        fields.forEach(initField);
        form.addEventListener('submit', event => {
            event.preventDefault();
            requestLogin();
        });


        function showPassword() {
            passwordToggler.classList.add('is--shown');
            passwordInput.setAttribute('type', 'text');
        }

        function hidePassword() {
            passwordToggler.classList.remove('is--shown');
            passwordInput.setAttribute('type', 'password');
        }

        function togglePassword() {
            passwordToggler.classList.contains('is--shown') ? hidePassword() : showPassword();
        }

        function initField(field) {
            const input = field.querySelector('.-input');
            input.addEventListener('focus', check);
            input.addEventListener('blur', check);
            check();

            function check() {
                if (input.value) {
                    input.classList.add('is--active');
                } else {
                    input.classList.remove('is--active');
                }
            }
        }

        function requestLogin() {
            const user = emailInput.value,
                  pass = passwordInput.value;

            MomAPI.login(user, pass, 0, function(data) {

                if (data.LoggedIn) {
                    Cookies.set('momentum_login', 'true', { expires: 1 });
                    Cookies.set('full_name', data.FullName, { expires: 1 });
                    Cookies.set('intern_client', data.InternClient, { expires: 1 });
                    if (MOMENTUM.url) {
                        window.location.href = `?extra=${MOMENTUM.url}`;
                    } else {
                        window.location.href = window.MOMENTUM.defaultLandingUrl || '/404';
                    }
                } else {
                    if (data.ReturnCode === 'BLOCKED') {
                        alert('Inloggningen misslyckades för att du är blockerad i systemet, kontakta oss för mer information.');
                    } else {
                        alert('Användarnamn eller lösenordet är felaktig.');
                    }
                }
            });
        }
    }
}
